import { Button, Box, Flex } from 'theme-ui';
import SpinnerBar from '~/components/Spinner/loader';
import { useState } from 'react';
import PlayWhiteSmall from '~/assets/images/icons/play-white-small.svg';
import CollectionLink from '~/components/Collection/Link';
import { forwardRef } from 'react';

const AnimatedButton = forwardRef(({ loading, playButton, children, alt, sx, ...props }, ref) => {
  const [hoverOn, setHover] = useState(false);

  return (
    <Box>
      {playButton && (
        <PlayWhiteSmall
          sx={{
            display: ['block'],
            position: 'absolute',
            width: '11px',
            height: '11px',
            fill: hoverOn ? (alt ? 'white' : 'black') : alt ? 'black' : 'white',
            mt: `18px`,
            pl: '1px',
            ml: '5px',
            zIndex: 3,
            transition: '0.35s ease',
          }}
        />
      )}
      <Button
        ref={ref}
        onMouseOver={() => setHover(true)}
        onMouseOut={() => setHover(false)}
        {...props}
        sx={{
          '&:enabled': {
            position: 'relative',
            '[data-testid="spinner"]': { color: 'var(--color)', transition: 'color 0.7s ease' },
            '&:hover': {
              backgroundColor: 'var(--background-color) !important',
              color: 'var(--color) !important',
              '[data-testid="spinner"]': { color: 'var(--background-color)' },
              '&:before': {
                clipPath: 'circle(100% at 50% 50%)',
              },
            },
            '&:before': {
              content: `"${loading ? '' : children}"`,
              position: 'absolute',
              width: '102%',
              height: '103%',
              color: 'var(--background-color)',
              backgroundColor: 'var(--color)',
              left: '-2px',
              top: '-1px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              pl: playButton && '0px',
              clipPath: 'circle(0% at 50% 50%)',
              transition: 'clip-path 0.35s ease',
              borderRadius: 'inherit',
            },
          },
          ...sx,
        }}
      >
        {loading ? (
          <Flex>
            <SpinnerBar startPercent={70} />
          </Flex>
        ) : (
          children
        )}
      </Button>
    </Box>
  );
});
export default AnimatedButton;
